import {gql} from '@apollo/client'

export const LOG_ENTRY_QUERY = gql`
  mutation logEntry($message: String!, $versionUuid: String) {
    logEntry(message: $message, versionUuid: $versionUuid) {
      message
      versionUuid
    }
  }
`
